module.exports = __webpack_public_path__ + "img/undraw_version_control_9bpv.577b3c89.svg";